<template>
  <div id="about">
			<div class="about" id="message">
				<div class="application-line" id="app-name">
					<h1>ABOUT</h1>
				</div>

				<div class="about-line" >
					<div class="about-column">
						<h2>Me:</h2>
						<img  src="../assets/images/me/myPhoto.jpg" style=" border-radius: 50%;width:100%">
						<h2>Alinouski Aliaksei</h2>
					</div>
					<div class="about-column">
							<h2>Contacts:</h2>
						<div class="contact">
							<a target="_blank" rel="noopener noreferrer" href='https://vk.com/broff_evoro'>
								<img alt='vk profile' src='../assets/images/SocialNetworks/vk.png' style="width:100%"/>
							</a>
							<a target="_blank" rel="noopener noreferrer" href='https://t.me/alinouski'>
								<img alt='telegram' src='../assets/images/SocialNetworks/telegram.svg' style="width:100%"/>
							</a>
							<a target="_blank" rel="noopener noreferrer" href='mailto:alinouski@gmail.com'>
								<img alt='mail' src='../assets/images/SocialNetworks/mail.svg' style="width:100%"/>
							</a>
						</div>								
					</div>
					<div class="about-column">
						<h2>Stack:</h2>
						<p><h3>Unity3d</h3>
						<p><h3>C# .Net</h3>
						<p><h3>Spring Java</h3>
					</div>
				</div>
				<div class="spacer" style="clear: both;"></div>		
			</div>
		</div>
</template>

<script>
export default {
}
</script>


// WEBPACK FOOTER //
// src/components/About.vue